(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const shop = root.querySelector('[data-slp-shop]');
    const views = Array.from(root.querySelectorAll('[data-slp-view]'));
    const modeButtons = Array.from(root.querySelectorAll('[data-slp-mode]'));
    const panels = Array.from(root.querySelectorAll('[data-slp-panel]'));
    const directPanels = Array.from(root.querySelectorAll('[data-slp-direct-panels] [data-slp-panel]'));
    const guidePanels = Array.from(root.querySelectorAll('[data-slp-guide-panels] [data-slp-panel]'));
    const picks = Array.from(root.querySelectorAll('[data-slp-pick]'));
    const areas = Array.from(root.querySelectorAll('[data-slp-area]'));
    const modelSelect = root.querySelector('[data-slp-model-select]');
    const sticky = root.querySelector('[data-slp-sticky]');
    const stickyBuy = root.querySelector('[data-slp-sticky-buy]');
    let mode = 'direct';
    let directModel = modelSelect?.value;
    let guideModel;
    let activePanel;
    let frame;
    const checkedVariant = panel => panel?.querySelector('[data-slp-variant]:checked');
    const alternative = root.querySelector('[data-slp-alternative]');
    const panelAvailable = panel => Array.from(panel.querySelectorAll('[data-slp-variant]')).some(input => input.dataset.available === 'true');
    const updateSticky = () => {
      if (!sticky || !activePanel || !shop) {
        if (sticky) sticky.hidden = true;
        return;
      }
      const variant = checkedVariant(activePanel);
      const form = activePanel.querySelector('form');
      const purchase = activePanel.querySelector('[data-slp-submit]');
      const buyRect = purchase.getBoundingClientRect();
      sticky.querySelector('[data-slp-sticky-title]').textContent = activePanel.querySelector('h3').childNodes[0].textContent.trim();
      sticky.querySelector('[data-slp-sticky-price]').textContent = variant.dataset.price;
      stickyBuy.setAttribute('form', form.id);
      stickyBuy.disabled = variant.dataset.available !== 'true' || form.getAttribute('aria-busy') === 'true';
      sticky.hidden = variant.dataset.available !== 'true' || shop.getBoundingClientRect().top > window.innerHeight * .55 || root.getBoundingClientRect().bottom < 130 || (buyRect.top >= 0 && buyRect.bottom <= window.innerHeight - 16);
    };
    const scheduleSticky = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = undefined; updateSticky(); });
    };
    const syncVariant = panel => {
      const variant = checkedVariant(panel);
      if (!variant) return;
      const available = variant.dataset.available === 'true';
      panel.querySelector('[data-slp-price]').textContent = variant.dataset.price;
      panel.querySelector('[data-slp-product-link]').href = variant.dataset.url;
      panel.querySelector('[data-slp-unavailable]').hidden = available;
      panel.querySelector('[data-slp-stock-link]').hidden = available;
      panel.querySelector('[data-slp-submit]').disabled = !available;
      panel.querySelector('[data-slp-submit]').hidden = !available;
      const contact = panel.querySelector('[data-slp-contact]');
      const context = `${panel.dataset.quantity} × EVO ${panel.dataset.model}, ${variant.dataset.dimmer}`;
      contact.href = `https://wa.me/491625392569?text=${encodeURIComponent(context)}`;
      if (panel === activePanel && alternative) alternative.hidden = available || !directPanels.some(panelAvailable);
      panel.querySelector('form').removeAttribute('aria-busy');
      updateSticky();
    };
    const showPanel = () => {
      const currentPanels = mode === 'direct' ? directPanels : guidePanels;
      const model = mode === 'direct' ? directModel : guideModel;
      activePanel = currentPanels.find(panel => panel.dataset.model === model);
      panels.forEach(panel => { panel.hidden = panel !== activePanel; });
      if (activePanel) activePanel.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      if (alternative) alternative.hidden = !activePanel || checkedVariant(activePanel)?.dataset.available === 'true' || !directPanels.some(panelAvailable);
      picks.forEach(pick => {
        const active = pick.dataset.slpPick === directModel;
        pick.classList.toggle('is-active', active);
        if (active) pick.setAttribute('aria-current', 'true');
        else pick.removeAttribute('aria-current');
      });
      areas.forEach(area => {
        const active = area.dataset.slpArea === guideModel;
        if (active) area.setAttribute('aria-current', 'true');
        else area.removeAttribute('aria-current');
      });
      if (activePanel) syncVariant(activePanel);
      else updateSticky();
    };
    const setMode = next => {
      if (!views.some(view => view.dataset.slpView === next)) return;
      mode = next;
      views.forEach(view => { view.hidden = view.dataset.slpView !== mode; });
      modeButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.slpMode === mode)));
      showPanel();
    };
    const navigateToShop = event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      setMode(event.currentTarget.dataset.slpPath || 'direct');
      shop.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'start' });
      shop.querySelector('h2').focus({ preventScroll: true });
    };
    if (directPanels.length && modelSelect) {
      const requestedModel = new URLSearchParams(window.location.search).get('model');
      if (directPanels.some(panel => panel.dataset.model === requestedModel)) {
        directModel = requestedModel;
        modelSelect.value = requestedModel;
      }
      root.querySelector('[data-slp-modes]').hidden = false;
      setMode('direct');
      modeButtons.forEach(button => button.addEventListener('click', () => setMode(button.dataset.slpMode)));
      root.querySelector('[data-slp-show-available]')?.addEventListener('click', () => {
        const next = directPanels.find(panelAvailable);
        if (!next) return;
        directModel = next.dataset.model;
        modelSelect.value = directModel;
        setMode('direct');
        shop.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'start' });
        modelSelect.focus({ preventScroll: true });
      });
      root.querySelectorAll('[data-slp-path]').forEach(link => link.addEventListener('click', navigateToShop));
      root.querySelectorAll('.slp-nav__cta, .slp-closing .slp-button').forEach(link => link.addEventListener('click', navigateToShop));
      picks.forEach(pick => pick.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        directModel = pick.dataset.slpPick;
        modelSelect.value = directModel;
        showPanel();
      }));
      modelSelect.addEventListener('change', () => { directModel = modelSelect.value; showPanel(); });
      areas.forEach(area => area.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        guideModel = area.dataset.slpArea;
        showPanel();
      }));
      panels.forEach(panel => {
        panel.querySelectorAll('[data-slp-variant]').forEach(input => input.addEventListener('change', () => syncVariant(panel)));
        panel.querySelector('form').addEventListener('submit', event => {
          const form = event.currentTarget;
          if (checkedVariant(panel).dataset.available !== 'true' || form.getAttribute('aria-busy') === 'true') {
            event.preventDefault();
            return;
          }
          form.setAttribute('aria-busy', 'true');
          panel.querySelector('[data-slp-submit]').disabled = true;
          updateSticky();
        });
      });
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky);
    }
    const restoreForms = () => {
      panels.forEach(syncVariant);
      setMode(mode);
    };
    window.addEventListener('pageshow', restoreForms);
    const targets = root.querySelectorAll('[data-slp-reveal]');
    let observer;
    if ('IntersectionObserver' in window && !motion.matches && !window.Shopify?.designMode) {
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }), { threshold: .08, rootMargin: '0px 0px 24px 0px' });
      targets.forEach(target => observer.observe(target));
      root.classList.add('is-enhanced');
    }
    const showAll = () => {
      if (motion.matches) {
        observer?.disconnect();
        root.classList.remove('is-enhanced');
      }
    };
    motion.addEventListener('change', showAll);
    const section = root.closest('.shopify-section') || root;
    section.addEventListener('shopify:section:unload', () => {
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('scroll', scheduleSticky);
      window.removeEventListener('resize', scheduleSticky);
      window.removeEventListener('pageshow', restoreForms);
      motion.removeEventListener('change', showAll);
    }, { once: true });
  };
  document.querySelectorAll('[data-sanlight-premium]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-sanlight-premium]').forEach(initialize);
  });
})();
